import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";
import { __awaiter, __generator } from "tslib";
import Vue from 'vue';
import { getMapKey, isUndef } from '@/lib/utils';
export var typeNameToPath = {
  province: '',
  city: '',
  county: ''
};
export var m = {
  namespaced: true,
  state: {
    rankV2: {},
    rankTemp: {},
    rankShare: {}
  },
  mutations: {
    initRankV2: function initRankV2(state, _a) {
      var forceUpdate = _a.forceUpdate,
          key = _a.key;
      var wrap = state.rankV2[key];

      if (wrap && forceUpdate) {
        wrap.loaded = wrap.req = false;
      } else {
        Vue.set(state.rankV2, key, {
          list: [],
          req: false,
          loaded: false
        });
      }
    },
    concatRankV2: function concatRankV2(state, _a) {
      var key = _a.key,
          list = _a.list,
          offset = _a.offset,
          forceUpdate = _a.forceUpdate;
      list.forEach(function (ele, idx) {
        Vue.set(state.rankV2[key].list, offset + idx, ele);
      });

      if (forceUpdate) {
        state.rankV2[key].list = state.rankV2[key].list.slice(0, list.length);
      }
    },
    setRankV2Req: function setRankV2Req(state, _a) {
      var key = _a.key,
          req = _a.req;
      state.rankV2[key].req = req;
    },
    setRankV2Loaded: function setRankV2Loaded(state, _a) {
      var key = _a.key,
          loaded = _a.loaded;
      state.rankV2[key].loaded = loaded;
    },
    setRankTemp: function setRankTemp(state, _a) {
      var list = _a.list,
          activityId = _a.activityId;
      Vue.set(state.rankTemp, activityId, list);
    },
    initRankShare: function initRankShare(state, _a) {
      var forceUpdate = _a.forceUpdate,
          key = _a.key;
      var wrap = state.rankShare[key];

      if (wrap && forceUpdate) {
        wrap.loaded = wrap.req = false;
      } else {
        Vue.set(state.rankShare, key, {
          list: [],
          req: false,
          loaded: false
        });
      }
    },
    concatRankShare: function concatRankShare(state, _a) {
      var key = _a.key,
          list = _a.list,
          offset = _a.offset,
          forceUpdate = _a.forceUpdate;
      list.forEach(function (ele, idx) {
        Vue.set(state.rankShare[key].list, offset + idx, ele);
      });

      if (forceUpdate) {
        state.rankShare[key].list = state.rankShare[key].list.slice(0, list.length);
      }
    },
    setRankShareReq: function setRankShareReq(state, _a) {
      var key = _a.key,
          req = _a.req;
      state.rankShare[key].req = req;
    },
    setRankShareLoaded: function setRankShareLoaded(state, _a) {
      var key = _a.key,
          loaded = _a.loaded;
      state.rankShare[key].loaded = loaded;
    }
  },
  actions: {
    getRankV2: function getRankV2(_a, _b) {
      var _c;

      var state = _a.state,
          commit = _a.commit,
          dispatch = _a.dispatch;
      var offset = _b.offset,
          count = _b.count,
          activityId = _b.activityId,
          typeKey = _b.typeKey,
          levelId = _b.levelId,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var key, wrap, rdata, res, list, map, res, list, res, path, res;
        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              key = getMapKey({
                activityId: activityId,
                typeKey: typeKey,
                levelId: levelId
              });
              wrap = state.rankV2[key];

              if (isUndef(wrap) || forceUpdate) {
                commit('initRankV2', {
                  key: key,
                  forceUpdate: forceUpdate
                });
                wrap = state.rankV2[key];
              }

              if (wrap.loaded || wrap.req) {
                return [2
                /*return*/
                ];
              }

              commit('setRankV2Req', {
                key: key,
                req: true
              });
              rdata = null;
              if (!['team_thumb_up_rank', 'user_thumb_up_rank'].includes(typeKey)) return [3
              /*break*/
              , 2];
              return [4
              /*yield*/
              , Vue.axios.get("/api/v1/activity/" + typeKey, {
                params: {
                  offset: offset,
                  count: count,
                  id: activityId
                }
              })];

            case 1:
              res = _d.sent();
              list = ((_c = res.data) === null || _c === void 0 ? void 0 : _c.data.list) || [];
              console.log('target 啊啊1', res.data);
              rdata = {
                status: res.data.status,
                // TeamThumbUpItem | UserThumbUpItem
                data: list.map(function (ele) {
                  var score = 0;
                  var title = '';
                  var cover = '';

                  if (typeKey === 'team_thumb_up_rank') {
                    score = ele.count;
                    title = ele.name;
                    cover = ele.logo;
                  } else if (typeKey === 'user_thumb_up_rank') {
                    score = ele.thumb_up_count;
                    title = ele.nickname;
                  }

                  return {
                    title: title,
                    score: score,
                    cover: cover
                  };
                })
              };
              return [3
              /*break*/
              , 8];

            case 2:
              if (!['team_distance', 'team_sign_in_rate', 'user_distance', 'user_days'].includes(typeKey)) return [3
              /*break*/
              , 4];
              map = {
                team_sign_in_rate: 'rank/getTeamRank',
                team_distance: 'rank/getTeamDistance',
                user_distance: 'rank/getTotalDistanceRank',
                user_days: 'rank/getTotalDaysRank'
              };
              return [4
              /*yield*/
              , dispatch(map[typeKey], {
                levelId: levelId,
                activityId: activityId,
                offset: offset,
                count: count,
                forceUpdate: forceUpdate
              }, {
                root: true
              })];

            case 3:
              res = _d.sent();
              list = res.data.list || [];
              rdata = {
                status: res.status,
                data: list.map(function (ele) {
                  return {
                    // @ts-ignore
                    title: ele.name || ele.nickname,
                    // @ts-ignore
                    score: typeKey === 'team_sign_in_rate' ? ele.rate : ele.total_distance || ele.count || 0,
                    cover: typeKey.indexOf('team') > -1 ? ele.logo : ''
                  };
                })
              };
              return [3
              /*break*/
              , 8];

            case 4:
              if (!['team_member_count'].includes(typeKey)) return [3
              /*break*/
              , 6];
              return [4
              /*yield*/
              , dispatch('getRankTemp', activityId)];

            case 5:
              res = _d.sent();
              console.log('target ranktempres', res);
              rdata = {
                status: res.status,
                data: res.data.map(function (ele) {
                  return {
                    title: ele.name,
                    score: ele.member_count
                  };
                })
              };
              return [3
              /*break*/
              , 8];

            case 6:
              path = typeKey.replace('_', '/');
              return [4
              /*yield*/
              , Vue.axios.get("/api/v1/rank/" + path, {
                params: {
                  offset: offset,
                  count: count,
                  activity_id: activityId
                }
              })];

            case 7:
              res = _d.sent();
              rdata = res.data;
              _d.label = 8;

            case 8:
              commit('setRankV2Req', {
                key: key,
                req: false
              });

              if (rdata.status === 0) {
                commit('concatRankV2', {
                  offset: offset,
                  list: rdata.data,
                  forceUpdate: forceUpdate,
                  key: key
                });

                if (rdata.data.length < count) {
                  commit('setRankV2Loaded', {
                    key: key,
                    loaded: true
                  });
                }
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    getRankTemp: function getRankTemp(_a, activityId) {
      var commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var res, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get("/api/v1/team/top_50", {
                params: {
                  activity_id: activityId
                }
              })];

            case 1:
              res = _b.sent();
              rdata = res.data;

              if (rdata.status === 0) {
                commit('setRankTemp', {
                  activityId: activityId,
                  list: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    getRankShare: function getRankShare(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var offset = _b.offset,
          count = _b.count,
          activityId = _b.activityId,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var key, wrap, res, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              key = getMapKey({
                activityId: activityId
              });
              wrap = state.rankShare[key];

              if (isUndef(wrap) || forceUpdate) {
                commit('initRankShare', {
                  key: key,
                  forceUpdate: forceUpdate
                });
                wrap = state.rankShare[key];
              }

              if (wrap.loaded || wrap.req) {
                return [2
                /*return*/
                ];
              }

              commit('setRankShareReq', {
                key: key,
                req: true
              });
              return [4
              /*yield*/
              , Vue.axios.get("/api/v1/invite/23rank", {
                params: {
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              res = _c.sent();
              rdata = res.data;
              commit('setRankShareReq', {
                key: key,
                req: false
              });

              if (rdata.status === 0) {
                commit('concatRankShare', {
                  offset: offset,
                  list: rdata.data,
                  forceUpdate: forceUpdate,
                  key: key
                });

                if (rdata.data.length < count) {
                  commit('setRankShareLoaded', {
                    key: key,
                    loaded: true
                  });
                }
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};